module.exports = __webpack_public_path__ + "create-big.png?950d607583a86fe5d78aeeaf7b414ff7";